/* eslint-disable @typescript-eslint/prefer-for-of */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthProvider } from '../../../services/auth.provider';
import { GaEventTrackerProvider } from '../../../services/gaeventtracker.provider';
import { Multitenant } from 'src/app/services/multitenant.provider';
import { ConfigService } from '../../../services/config.service';
import { Oneperweek } from '../../../services/oneperweek';
import { Article } from '../../../models/article.model';
import { PopUp } from '../../../models/popup.model';
import { replaceWithNbspBeforeArray, sharedItems } from '../../utils';

@Component({
  selector: 'app-card',
  templateUrl: 'card.html',
  styleUrls: ['card.scss']
})
export class CardComponent implements OnInit{
  @Input() articles: Array<Article>;
  @Input() i: number;
  @Input() article: Article;
  @Input() video: { [key: number]: boolean } = {};
  @Input() themeClass: string;
  @Input() category: string;
  @Output() public activatePopUp: EventEmitter<boolean> = new EventEmitter();
  @Output() public showOnePerWeek: EventEmitter<PopUp> = new EventEmitter();
  public authenticated: boolean;
  public locale: string;
  public hiddenImage: boolean;
  private popup: PopUp = new PopUp();

  constructor(
    public auth: AuthProvider,
    private oneperweek: Oneperweek,
    private ga: GaEventTrackerProvider,
    private config: ConfigService,
    private multiTenant: Multitenant,
    private actRoute: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {

    replaceWithNbspBeforeArray.forEach(
      el => {
        const escapedTarget = el.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(`\\s+${escapedTarget}`, 'g');
        this.article.article_title = this.article.article_title.replace(regex, '&nbsp' + el);
        this.article.article_content = this.article.article_content.replace(regex, '&nbsp' + el);
        this.article.article_subtitle = this.article.article_subtitle ? this.article.article_subtitle.replace(regex, '&nbsp' + el) : undefined;
        this.article.article_subhead = this.article.article_subhead ? this.article.article_subhead.replace(regex, '&nbsp' + el) : undefined;
        this.article.article_content_excerpt = this.article.article_content_excerpt ? this.article.article_content_excerpt.replace(regex, '&nbsp' + el) : undefined;
      }
    );

    this.authenticated = this.auth.isAuthenticated();
    this.hiddenImage = !this.auth.isAuthenticated() && this.article.image_copyright && this.article.image_copyright.includes('AFP');
    if (this.multiTenant.getDomainClass() === 'mwjp') {
      this.locale = 'ja';
    } else if (
      this.multiTenant.getDomainClass() === 'week' ||
      this.multiTenant.getDomainClass() === 'mlwk'
    ) {
      this.locale = 'en';
    } else if (this.multiTenant.getDomainClass() === 'sema') {
      this.locale = 'es';
    } else if (
      this.multiTenant.getDomainClass() === 'woch' ||
      this.multiTenant.getDomainClass() === 'mwde'
    ) {
      this.locale = 'de';
    } else {
      this.locale = this.config.getLocale();
    }
  }

  public navigateToDetail(article) {
    if (article.article_type === 'pub') {
      window.open(article.article_url);
    } else if (article.article_type === 'livre-pub') {
      this.router.navigate(['actu-livres', article.article_slug]);
    } else {
      this.oneperweek.checkOnePerWeek(article.article_id, article.newspaper_subname, article.is_excluded_from_paywall);
      if (this.oneperweek.pass || article.is_free === true) {
        this.router.navigate(['article', article.article_slug], { queryParams: { category: this.category } });
      } else {
        if (article.is_excluded_from_paywall) {
          this.popup.type = 'excludedFromPaywall';
          this.popup.data = article.newspaper_subname == 'acne' ? 'L\'ACTU' : article.newspaper_name;
        } else {
          this.popup.type = 'five';
          this.popup.data = this.oneperweek.remainingDays.toString();
        }
        this.popup.platform = this.themeClass;
        this.popup.article_type = article.newspaper_subname;
        this.activatePopUp.emit(true);
        this.showOnePerWeek.emit(this.popup);
      }
    }
  }

  public open(article, index) {
    this.oneperweek.checkOnePerWeek(article.article_id, article.newspaper_subname, article.is_excluded_from_paywall);
    if (this.oneperweek.pass || article.is_free === true) {
      this.articles[index].isOpen = !this.articles[index].isOpen;
    } else {
      if (article.is_excluded_from_paywall) {
        this.popup.type = 'excludedFromPaywall';
        this.popup.data = article.newspaper_subname == 'acne' ? 'L\'ACTU' : article.newspaper_name;
      } else {
        this.popup.type = 'five';
        this.popup.data = this.oneperweek.remainingDays.toString();
      }
      this.popup.platform = this.themeClass;
      this.popup.article_type = article.newspaper_subname;
      this.activatePopUp.emit(true);
      this.showOnePerWeek.emit(this.popup);
    }
  }

  public playVideo(article) {
    this.ga.sendVideoArticle(article.newspaper_subname, article.article_slug);
    this.oneperweek.checkOnePerWeek( article.article_id, article.newspaper_subname, article.is_excluded_from_paywall);

    if (this.oneperweek.pass || article.is_free === true) {
      this.video[article.article_id] = true;
      setTimeout( () => {
        const timeframe = document.getElementsByTagName('iframe');
        if (timeframe.length > 0) {
          for (let i = 0; i < timeframe.length; i++) {
            timeframe[i].width = '100%';
          }
        }
      }, 1000);
    } else {
      if (article.is_excluded_from_paywall) {
        this.popup.type = 'excludedFromPaywall';
        this.popup.data = article.newspaper_subname == 'acne' ? 'L\'ACTU' : article.newspaper_name;
      } else {
        this.popup.type = 'five';
        this.popup.data = this.oneperweek.remainingDays.toString();
      }
      this.popup.platform = this.themeClass;
      this.popup.article_type = article.newspaper_subname;
      this.activatePopUp.emit(true);
      this.showOnePerWeek.emit(this.popup);
    }
  }

  public filterByLogo(newspaper: string, category?: string) {
    if (this.auth.isAuthenticated()) {
      this.router.navigate([''], { queryParams: { filter: newspaper, category } });
    } else {
      const conf = this.config.getEnvironmentConfig();
      let newspapers: Array<any>;
      if (conf.env === 'testing') {
        newspapers = conf.all_newspapers;
        newspapers.forEach( (item) => {
          if (item.subname === newspaper) {
            window.open(item.url, '_blank');
          }
        });
      }

      if (conf.env === 'prod') {
        newspapers = conf.all_newspapers_prod;
        newspapers.forEach( (item) => {
          if (item.subname === newspaper) {
            window.open(item.url, '_blank');
          }
        });
      }
    }
  }

  public goToExtract(url) {
    window.open(url, '_blank');
  }

  public goToAllBooks() {
    if (this.themeClass !== 'playbacpresse') {
      this.router.navigate(['actu-livres']);
    } else {
      if (this.actRoute.snapshot.queryParams.filter && this.actRoute.snapshot.queryParams.filter === 'lepq') {
        window.open('http://lepq.playbacpresse.test.revsquare.com', '_blank');
      }
      if (this.actRoute.snapshot.queryParams.filter && this.actRoute.snapshot.queryParams.filter === 'mquo') {
        window.open('http://mquo.playbacpresse.test.revsquare.com', '_blank');
      }
      if (this.actRoute.snapshot.queryParams.filter && this.actRoute.snapshot.queryParams.filter === 'actu') {
        window.open('http://actu.playbacpresse.test.revsquare.com', '_blank');
      }
    }
  }

  public hexToRgba(hex: string = '#FFFFFF', opacity: number = 1): string {
    if (!hex) {
      return 'rgba(255, 255, 255, 0)';
    }
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return `rgba(${parseInt(result[1], 16)},${parseInt( result[2], 16 )},${parseInt(result[3], 16)},${opacity})`;
  }

  public getInclude(article) {
    if ( !this.auth.isAuthenticated() || (this.auth.isAuthenticated() && this.auth.getActiveProfile() === 'Children') ) {
      return sharedItems(article.newspaper_subname);
    } else {
      return ['facebook', 'twitter', 'email', 'whatsapp'];
    }
  }
}
